import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';

import type { MenuItemType } from '../../types/menu-item.type';
import { BtnActionEnum } from '../../types/menu-item.type';

@Injectable({
  providedIn: 'root',
})
export class ActionService {
  #destroyRef = inject(DestroyRef);

  public handleAction(item: MenuItemType, destroyRef?: DestroyRef): void {
    if (!item.action) return;

    switch (item.action.type) {
      case BtnActionEnum.CALLBACK:
        item.action.callbackOrUrl();
        break;
      case BtnActionEnum.URL:
        if (typeof item.action.callbackOrUrl === 'string') {
          window.open(item.action.callbackOrUrl, '_blank');
        } else {
          item.action.callbackOrUrl
            .pipe(
              takeUntilDestroyed(destroyRef ?? this.#destroyRef),
              tap((url: string) => window.open(url, '_blank')),
            )
            .subscribe();
        }

        break;
      default:
        return;
    }
  }

  public isActionInteractive(item: MenuItemType): boolean {
    if (item.action) {
      return item.action.type === BtnActionEnum.CALLBACK;
    }

    return false;
  }

  public isActionURL(item: MenuItemType): boolean {
    if (item.action) {
      return item.action.type === BtnActionEnum.URL;
    }

    return false;
  }
}
